import React from 'react'

export default function MarginTopBottom({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path d='M5 3H15H5Z' fill={color} />
            <path d='M5 3H15' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
            <rect x='5' y='6' width='10' height='8' rx='2' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
            <path d='M5 17H15' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
